<template>
	<header class="checkoutHeader container">
		<div class="checkoutHeader__ContentWrapper">
			<div>
				<button @click="goBack" :aria-label="$t('back')">
					<Icon name="arrow-left" />
					<span>{{ $t('back') }}</span>
				</button>
			</div>

			<nuxt-link :to="link('Home')" class="checkoutHeader__Logo">
				<Icon name="logo" />
			</nuxt-link>

			<div>
				<button :aria-label="$t('contact')" @click="open('contact')">
					<Icon name="phone" />
					<span>{{ $t('header.contact') }}</span>
				</button>
			</div>
		</div>
	</header>

	<Teleport to="body">
		<Modal v-show="dialogs.contact" v-model="dialogs.contact" class="modal__Contact">
			<ContactDropdown />
		</Modal>
	</Teleport>
</template>

<script setup>
	const { link } = useSetup();
	const contactDialog = ref(false);
	const { activeCheckoutStep } = useCheckout();
  
	const dialogs = reactive({
		contact: false,
	});

	const { open } = useModal(dialogs);

	async function goBack() {
		activeCheckoutStep.value === 1
			? await navigateTo({ path: link('AccommodationUnitList'), query: useRoute().query })
			: activeCheckoutStep.value--;
	}

	function toggleContactDialog() {
		contactDialog.value = !contactDialog.value;
	}
</script>

<style lang="scss">
	@import url('@/assets/styles/components/_checkoutHeader.scss');
</style>
